/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelEditAPIRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EditRestApi<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description edit rest api
   *
   * @tags api
   * @name EditRestApiCreate
   * @summary edit rest api
   * @request POST:/editRestApi
   */
  editRestApiCreate = (
    request: ModelEditAPIRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/editRestApi`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
